module.exports = __webpack_public_path__ + "static/img/eli_lilly_300x250.4659954d.jpg";